var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilledPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 6,
    fill: "#D6DEF5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_226_25062)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 10C16.4178 10 14.871 10.4692 13.5554 11.3482C12.2398 12.2273 11.2145 13.4767 10.609 14.9385C10.0035 16.4003 9.84504 18.0089 10.1537 19.5607C10.4624 21.1126 11.2243 22.538 12.3431 23.6569C13.462 24.7757 14.8874 25.5376 16.4393 25.8463C17.9911 26.155 19.5997 25.9965 21.0615 25.391C22.5233 24.7855 23.7727 23.7602 24.6518 22.4446C25.5308 21.129 26 19.5823 26 18C25.9977 15.879 25.1541 13.8455 23.6543 12.3457C22.1545 10.8459 20.121 10.0023 18 10V10ZM18 24.6667C16.6815 24.6667 15.3925 24.2757 14.2962 23.5431C13.1999 22.8106 12.3454 21.7694 11.8408 20.5512C11.3362 19.333 11.2042 17.9926 11.4614 16.6994C11.7187 15.4062 12.3536 14.2183 13.286 13.286C14.2183 12.3536 15.4062 11.7187 16.6994 11.4614C17.9926 11.2042 19.3331 11.3362 20.5512 11.8408C21.7694 12.3454 22.8106 13.1999 23.5431 14.2962C24.2757 15.3925 24.6667 16.6815 24.6667 18C24.6647 19.7675 23.9617 21.4621 22.7119 22.7119C21.4621 23.9617 19.7675 24.6647 18 24.6667ZM18.6667 17.3333H21.3333V18.6667H18.6667V21.3333H17.3333V18.6667H14.6667V17.3333H17.3333V14.6667H18.6667V17.3333Z",
    fill: "#0A1229"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_226_25062"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilledPlus);
export default __webpack_public_path__ + "static/media/filledPlus.598d479324682aea9e40dc203967f490.svg";
export { ForwardRef as ReactComponent };